import * as P from "../../program-state"
import { available_ctas_response_schema, available_ctas_response_t, get_available_ctas_request_t } from "../../resource/cta_types"

export const fetch_available_ctas = async (
    request : get_available_ctas_request_t,
    token : P.authn_token
) : Promise<available_ctas_response_t | null> => {
    const [ok, resp] = await P.issue_json_post(
        P.v1api`smart-campaign/available-ctas/`,
        request,
        available_ctas_response_schema,
        token
    )

    if (!ok) {
        console.log("Error fetching available CTAs", resp)
        return null
    }

    return resp
}
